import * as React from 'react';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var SuggestDesktopList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("ul", {
    ref: ref,
    role: "listbox",
    className: styles['list'],
    style: {
      maxHeight: props.maxHeight
    },
    "data-testid": "suggest-desktop-list",
    children: props.children
  });
});
SuggestDesktopList.displayName = 'SuggestDesktopList';